<template>
  <!-- 课程方名称 -->
  <a-form-item label="课程方名称">
    <a-select
      showSearch
      :allowClear="true"
      class="form-cell"
      placeholder="请选择来自的课程方"
      :filterOption="false"
      @search="searchInstitution"
      :notFoundContent="searchInstitutionLoading ? undefined : '没有查询结果'"
      v-model="modelInstitution"
    >
      <a-spin
        v-if="searchInstitutionLoading"
        slot="notFoundContent"
        size="small"
      />
      <a-select-option v-for="d in institutionList" :key="d.id">{{
        d.institutionName
      }}</a-select-option>
    </a-select>
  </a-form-item>
</template>
<script>
import institution from '../../api/institution'

export default {
  name: 'CInstitutionSelect',
  props: ['institutionCode'],
  data() {
    return {
      searchInstitutionLoading: false, //搜索课程方loading
      institutionList: [], //课程方list
      modelInstitution: this.institutionCode,
    }
  },
  watch: {
    modelInstitution() {
      this.$emit('update:institutionCode', this.modelInstitution)
    },
    institutionCode() {
      console.log('this.institutionCode', this.institutionCode)
      this.modelInstitution = this.institutionCode
    },
  },
  methods: {
    //搜索课程方
    searchInstitution(val = '') {
      this.searchInstitutionLoading = true
      institution.assessSearchInstitution({ institutionName: val }).then((res) => {
        console.log(res.data,'课程方名称')
        this.searchInstitutionLoading = false
        this.institutionList = res.data
        console.log(res.data,'课程方名称22222222')
      })
    },
  },
  created() {
    this.searchInstitution()
  },
}
</script>
